import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { MobileDrawer } from './MobileDrawer';

// Shell layout: CSS Grid `sidebar | main` on desktop, single column + drawer on mobile
// (handled by LeadKitchen v3 layout.css @media (max-width: 899px)).
export function AppShell() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  // Close the drawer on route change so navigation from drawer doesn't leave it open.
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  // Lock body scroll while the drawer is open (nicer mobile UX).
  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    const prev = document.body.style.overflow;
    if (mobileOpen) document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [mobileOpen]);

  return (
    <div className="lk-app">
      <Sidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />
      <MobileDrawer open={mobileOpen} onClose={() => setMobileOpen(false)} />
      <div className="lk-main">
        <Topbar onOpenMobileMenu={() => setMobileOpen(true)} />
        <main className="lk-main__content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
